import errors from 'locales/en/errors';
import { escapedCountry } from 'utils/transform';

export const disputesTable = {
  header: 'All Disputes',
  export: 'Export Disputes',
  id: 'Dispute ID',
  amount: 'Amount',
  fee: 'Fee',
  transactionId: 'Transaction Id',
  reason: 'Reason',
  status: 'Status',
  date: 'Date',
  daysToDefend: 'Days to Defend',
  defenceSubmitted: 'Defence Submitted',

  search: 'Search disputes',
};

export const rowActions = {
  view: 'View Dispute Details',
  submit: 'Submit Defence',
};

export const disputeDetails = {
  header1: 'Dispute',

  detailsHeader: 'Dispute Details',
  submitEvidence: 'Submit Evidence',
  refund: 'Refund',
  error: 'Error',
  log: 'Log',

  date: disputesTable.date,
  customer_name: 'Customer name',
  payment_method: 'Payment method',
  risk_score: 'Fraud score',

  id: disputesTable.id,
  created_at: 'Created At',
  amount: disputesTable.amount,
  fee: disputesTable.fee,
  transactionId: disputesTable.transactionId,

  status: disputesTable.status,
  reason: disputesTable.reason,
  reason_code: 'Reason Code',
  defenceSubmitted: disputesTable.defenceSubmitted,
  daysToDefend: disputesTable.daysToDefend,
  reference: 'Reference',
};
export const evidenceForm = {
  name: disputeDetails.customer_name,
  email: 'Email',
  billing_address: 'Billing address',
  address_1: 'Address Line 1',
  address_2: 'Address Line 2',
  postcode: 'Postcode',
  city: 'City',
  country: escapedCountry,

  product_details: 'Product or Service details',
  physical: 'Physical Product',
  digital: 'Digital Product or Service',
  offline: 'Offline Service',
  booking: 'Booking or Reservation',
  event: 'Event',
  other: 'Other',
  description: 'Description (optional)',
  uploadLabel: 'Maximum of 5MB in total for evidence upload',
  defenceReason: 'Defence reason:  [response from API]',
  maxAdyen: 'Upload a PDF document.  Maximum of 2MB in total for evidence upload.',

  supporting_evidence: 'Supporting Evidence',
  max: 'Maximum of 5MB in total for evidence upload',
  upload: 'Upload from computer',
  additional_info: 'Additional Information (optional)',

  submitInfo:
    'You must select Submit Evidence to pass the documentation to the bank for review. Once evidence is submitted, you cannot make changes.',
  submit: 'Submit Evidence',
  submitEvidenceSuccess:
    'You have successfully submitted evidence for this dispute.',
  submitEvidenceError: 'There was error in submitting evidence!',
  saveEvidenceError: 'There was error in saving the evidence!',
  save: 'Save',
  documentDeleteError: 'There was error in deleting document!',
  documentUploadError: 'There was error in uploading document!',

  errors: {
    name: 'Customer name is required',
    email: errors.email,
    address: 'Billing address is required',
    city: errors.city,
    country: errors.country,
    supporting_evidence: 'Supporting evidence is required',
    product: 'Please selection an option',
    file: {
      max: 'Uploaded file is too large. File size should be max 5MB',
      type: 'This file type is not supported. Please upload pdf, jpeg, jpg or png.',
      required: 'Please attach a file',
    },
    adyenEvidence: {
      max: 'Uploaded file is too large.',
      type: 'This file type is not supported. Please upload pdf, jpeg, jpg or png.',
      required: 'Please attach a file',
    },
  },
};
